<template>
  <div class="csv-convert-treatments-raku">
    <login-for-management v-slot="{ clinics }">
      <base-csv-import
        v-slot="{ uploadCsv }"
        titleText="診療項目コンバート(らく動物病院)"
        url="/csv-convert-treatments-raku"
        :clinics="clinics"
        :initialCsvData="makeInitialCsvData()"
        :makeConfirmText="makeConfirmText"
        @success="downloadCsv"
      >
        <div>変換元ファイル</div>
        <input type="file" @change="uploadCsv($event, 'priceInput')" />
      </base-csv-import>
    </login-for-management>
  </div>
</template>

<script>
import BaseCsvImport from '@/components/pages/BaseCsvImport'
import LoginForManagement from '@/components/pages/LoginForManagement'
import { stringify } from 'csv-stringify/lib/sync'
export default {
  name: 'CsvConvertTreatmentsRaku',

  components: {
    BaseCsvImport,
    LoginForManagement
  },

  computed: {},

  watch: {},

  methods: {
    makeInitialCsvData() {
      return {
        priceInput: null
      }
    },
    makeConfirmText(targetClinic) {
      return `「${targetClinic.name}」の診療項目データについて、\nインポート用のCSVを作成します。実行しますか？`
    },
    downloadCsv(res) {
      const allCsv = res.data.allCsv
      const csv1 = allCsv.treatmentLargeClassesCsv
      const csv2 = allCsv.treatmentClassesCsv
      const csv3 = allCsv.treatmentsCsv
      if (csv1.length > 0) {
        const csvStr1 = this.makeCsvStr(csv1)
        const fileName1 = 't01_treatment_large_classes.csv'
        this.downloadFunc(csvStr1, fileName1)
      }
      if (csv2.length > 0) {
        const csvStr2 = this.makeCsvStr(csv2)
        const fileName2 = 't02_treatment_classes.csv'
        this.downloadFunc(csvStr2, fileName2)
      }
      if (csv3.length > 0) {
        const csvStr3 = this.makeCsvStr(csv3)
        const fileName3 = 't03_treatments.csv'
        this.downloadFunc(csvStr3, fileName3)
      }
    },
    makeCsvStr(csv) {
      return stringify(csv, {
        cast: {
          boolean: function(value) {
            return value.toString()
          }
        },
        header: true,
        quoted: true
      })
    },
    downloadFunc(csvStr, fileName) {
      const bom = new Uint8Array([0xef, 0xbb, 0xbf])
      const blob = new Blob([bom, csvStr], { type: 'text/csv' })
      if (window.navigator.msSaveBlob) {
        window.navigator.msSaveBlob(blob, fileName)
      } else {
        const url = window.URL.createObjectURL(blob)
        const anchor = document.createElement('a')
        anchor.href = url
        anchor.download = fileName
        anchor.click()
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
